(() => {
  const css = `
    input,select,textarea{border-radius:0!important;font-size:16px!important}
    button,[type="submit"]{border-radius:0!important;font-size:16px!important}
    input:not([type="checkbox"],[type="radio"],[type="submit"]),select{box-sizing:border-box!important;height:48px!important}
    button span{margin: 0!important;}
    [class*="formInputFieldLabel"],input::placeholder,textarea::placeholder{color:var(--gray-text,#6f6f6f)!important;opacity:1!important}
    [class*="formSubmitButton"]{background:var(--btn-fill-bg,#111313)!important;color:var(--btn-fill-text,#fff)!important;border:1px solid var(--btn-fill-bg,#111313)!important}
    [class*="formSubmitButton"]:hover{background:var(--btn-fill-text,#fff)!important;color:var(--btn-fill-bg,#111313)!important}
  `;


  const fullWidthCss = `
    :host{display:block;width:100%}
    *,*::before,*::after{box-sizing:border-box}
    *{max-width:100%!important}
    form{width:99%}
  `;

  const addStyle = (root, textContent) =>
    root.appendChild(Object.assign(document.createElement('style'), { textContent }));

  const switcherLabel = (el) => {
    const suffix = el.closest('.shopify-app-block')?.id.split('__').pop();
    const input = suffix && document.querySelector(`input[data-target="${CSS.escape(suffix)}"]`);
    return input?.id ? document.querySelector(`label[for="${CSS.escape(input.id)}"]`)?.textContent : null;
  };

  const nameOf = (r, el) =>
    (r.querySelector('[class*="textHeading"]')?.textContent ||
      switcherLabel(el) ||
      [...document.querySelectorAll('h1,h2,h3')]
        .filter((h) => h.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING)
        .pop()?.textContent ||
      '').trim() || null;

  const bind = (r, el) => {
    const form = r.querySelector('form');
    if (!form) return false;

    const formId = el.closest('[data-form-root]')?.getAttribute('data-forms-id') || null;

    // The app renders role="dialog" with an empty aria-label
    const dialog = r.querySelector('[role="dialog"]');
    if (dialog && !dialog.getAttribute('aria-label')) dialog.setAttribute('aria-label', nameOf(r, el) || 'Formulier');

    form.addEventListener('submit', () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'shopify_form_submit', form_id: formId, form_name: nameOf(r, el) });
    });
    return true;
  };

  const enhance = (el) => {
    const r = el.shadowRoot;
    if (!r || el.dataset.gtmDone) return;
    el.dataset.gtmDone = '1';

    addStyle(r, css);
    if (el.closest('.image-with-text__app')) addStyle(r, fullWidthCss);

    // The app renders the form into the shadow root later, out of reach of the document observer.
    if (bind(r, el)) return;
    const obs = new MutationObserver(() => bind(r, el) && obs.disconnect());
    obs.observe(r, { childList: true, subtree: true });
  };

  const scan = () => document.querySelectorAll('shopify-forms-embed').forEach(enhance);

  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  scan();
})();
